import swal from 'sweetalert2';

const notifi = {
    error: (title, text, timer = 5500) => {
        swal.fire({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        icon: 'warning',
        timer: timer,
        })
    },

    success: (title, text, timer = 5500) => {
        swal.fire({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success',
        icon: 'success',
        timer: timer,
        })
    },
}

export default notifi;